module.exports = __webpack_public_path__ + "static/img/expert2.e88e16f0.png";